import React from "react";
import { Switch, Route } from "react-router-dom";

import Manage from "./pages/Manage";
import Dashboard from "./pages/Dashboard";
import Navigation from "./component/Navigation/Navigation";

import "./App.css";

function App() {
  return (
    <div>
      <Navigation />
      <Switch>
        <Route exact path="/" component={Dashboard} />
        <Route exact path="/manage" component={Manage} />
      </Switch>
      <footer>
        <p>jamorajj</p>
        <p>
          Made with{" "}
          <a
            href="https://reactjs.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            React
          </a>
        </p>
        <p>
          SpeechSyntesis API may not be available on all browsers since it's
          still experimental.
        </p>
      </footer>
    </div>
  );
}

export default App;
